import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';

import s from './EmptyEarningsList.scss';

interface Props {}

const EmptyEarningsList: FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <Section className={s['root']}>
      <img
        src="https://st.deviantart.net/eclipse/sisu/il4.6_sell_my_art_120px.png"
        alt={t('studio.earnings.emptyList.alt')}
      />
      <Heading className={s['header']}>{t('studio.earnings.emptyState.header')}</Heading>
      <div className={s['subheader']}>{t('studio.earnings.emptyState.subheader')}</div>
    </Section>
  );
};
EmptyEarningsList.displayName = 'EmptyEarningsList';

export default EmptyEarningsList;
